"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgoratto-mormorolo": {
    "346d4324": [{
      "hkey": "b38fb878",
      "slug": "borgoratto-mormorolo",
      "name": "Borgoratto Mormorolo",
      "primary": true,
      "skipSearch": false
    }],
    "braglia": [{
      "hkey": "b38fb878",
      "slug": "borgoratto-mormorolo",
      "name": "Borgoratto Mormorolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd77fa26": [{
      "hkey": "b38fb878",
      "slug": "borgoratto-mormorolo",
      "name": "Borgoratto Mormorolo",
      "primary": true,
      "skipSearch": false
    }],
    "casa-inveraghi": [{
      "hkey": "b38fb878",
      "slug": "borgoratto-mormorolo",
      "name": "Borgoratto Mormorolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "953ab0f1": [{
      "hkey": "b38fb878",
      "slug": "borgoratto-mormorolo",
      "name": "Borgoratto Mormorolo",
      "primary": true,
      "skipSearch": false
    }],
    "ferminco": [{
      "hkey": "b38fb878",
      "slug": "borgoratto-mormorolo",
      "name": "Borgoratto Mormorolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "68c48d2c": [{
      "hkey": "b38fb878",
      "slug": "borgoratto-mormorolo",
      "name": "Borgoratto Mormorolo",
      "primary": true,
      "skipSearch": false
    }],
    "gabbione": [{
      "hkey": "b38fb878",
      "slug": "borgoratto-mormorolo",
      "name": "Borgoratto Mormorolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;